import React, { useState, useEffect } from "react";
import ScrollToTopOnMount from "../../shared/components/ScrollToTopOnMount";
import { Container, makeStyles } from "@material-ui/core";
import ReactMarkdown from "react-markdown";
import Paragraph from "../../shared/markdownRendering/Paragraph";
import Heading from "../../shared/markdownRendering/Heading";
import ListItem from "../../shared/markdownRendering/ListItem";
import Link from "../../shared/markdownRendering/Link";
import Page from "../../shared/components/Page";

const useStyles = makeStyles((theme) => ({
  content: {
    paddingBottom: 120,
  },
  wrapper: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    height: "100%",
    overflow: "hidden",
    paddingTop: 0,
  },
  contentContainer: {
    flex: "1 1 auto",
    overflow: "auto",
  },
}));

function Terms() {
  const classes = useStyles();

  const [markdown, setMarkdown] = useState("");

  // https://github.com/webpack/webpack/issues/6680
  useEffect(() => {
    import("./terms.md")
      .then((content) => fetch(content.default))
      .then((response) => response.text())
      .then((responseText) => setMarkdown(responseText));
  });

  return (
    <Page title="Terms &mdash; Web Field Guide">
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <Container maxWidth="md" className={classes.content}>
            <ScrollToTopOnMount />
            <ReactMarkdown
              skipHtml={false}
              escapeHtml={false}
              renderers={{
                paragraph: Paragraph,
                heading: Heading,
                listItem: ListItem,
                link: Link,
              }}
            >
              {markdown}
            </ReactMarkdown>
          </Container>
        </div>
      </div>
    </Page>
  );
}

export default Terms;
